// extracted by mini-css-extract-plugin
module.exports = {"modal":"SevenFamilies_modal__0DHWK","content":"SevenFamilies_content__avcRA","message":"SevenFamilies_message__kf5Gx"};